// extracted by mini-css-extract-plugin
export default {"top_banner":"styles_top_banner__xuWsu","divider":"styles_divider__VmRCZ","view_edit":"styles_view_edit__5aUrL"};